import { createComponentWrapperWithRef, ListItem, styled } from '@msdk/ui'

import { NovaSidebarItem, SidebarItem } from './SidebarItem'

export const MuiSidebarListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'level' && prop !== 'last',
})<{
  level: number
  last?: boolean
}>`
  ${SidebarItem};
  padding-left: ${(props) => (props.level > 1 ? props.level * 16 : 8)}px;
  margin-bottom: ${(props) => {
    if (props.level === 0 && props.last) return 0
    return props.level === 0 ? '8px' : '4px'
  }};
  padding-top: ${(props) => {
    return props.level === 0 ? '8px' : '4px'
  }};
  padding-bottom: ${(props) => {
    return props.level === 0 ? '8px' : '4px'
  }};
`

export const NovaSidebarListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'level' && prop !== 'last',
})<{
  level: number
  last?: boolean
}>`
  ${NovaSidebarItem};
  padding-left: ${(props) => (props.level > 1 ? props.level * 16 : 8)}px;
  margin-bottom: ${(props) => {
    if (props.level === 0 && props.last) return 0
    return props.level === 0 ? '8px' : '4px'
  }};
  padding-top: ${(props) => {
    return props.level === 0 ? '8px' : '4px'
  }};
  padding-bottom: ${(props) => {
    return props.level === 0 ? '8px' : '4px'
  }};
`

export const SidebarListItem = createComponentWrapperWithRef(
  {
    mui: MuiSidebarListItem,
    nova: NovaSidebarListItem,
    novaProps: {
      disableGutters: true,
    },
  },
  'SidebarListItem',
)
